/**
 * @license lucide v0.469.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const TouchpadOff = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16" }],
    ["path", { d: "M2 14h12" }],
    ["path", { d: "M22 14h-2" }],
    ["path", { d: "M12 20v-6" }],
    ["path", { d: "m2 2 20 20" }],
    ["path", { d: "M22 16V6a2 2 0 0 0-2-2H10" }]
  ]
];

export { TouchpadOff as default };
//# sourceMappingURL=touchpad-off.js.map
